module.exports = __webpack_public_path__ + "img/26.d91f96e7.jpg";